skrilla.directive('dateTimePicker',function() {
    return {
        scope: {
            date: "=",
            placeholder: "="
        },
        controller: function($scope){

            if($scope.date === null || $scope.date === undefined){
                $scope.show = false;
                $scope.date = null;
            }
            else{
                $scope.show = true;
            }

            $scope.placeholder = $scope.placeholder || "Not set"

            $scope.clicked = function(){
                $scope.show =  true;
            }
            $scope.clearTime = function(){
                $scope.show = false;
                $scope.date = null;
            }

            $scope.dateOptions = {
                showWeeks: false,
                startingDay: 0
            };


            // Disable weekend selection
            $scope.disabled = function(calendarDate, mode) {
                return mode === 'day' && ( calendarDate.getDay() === 0 || calendarDate.getDay() === 6 );
            };



            $scope.dateOpened = false;
            $scope.hourStep = 1;
            $scope.minuteStep = 15;
            // add min-time="minTime" to datetimepicker to use this value
            //$scope.minTime = new Date(0, 0, 0, Math.max(1, $scope.date.getHours() - 2), 0, 0, 0);

            $scope.timeOptions = {
                hourStep: [1, 2, 3],
                minuteStep: [1, 5, 10, 15, 25, 30]
            };

            $scope.showMeridian = true;
            $scope.timeToggleMode = function() {
                $scope.showMeridian = !$scope.showMeridian;
            };

            $scope.$watch("date", function(newVal, oldVal) {
               $scope.date = newVal
            }, true);

            $scope.resetHours = function() {
               // $scope.date.setHours(1);
            };

        },
        templateUrl: 'directives/dateTimePicker/dateTimePicker.html'
    }
});
